import React from 'react';
import { Typography, Grid, Button } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import MarkdownImage from '@modules/ui/markdown/components/MarkdownImage';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';
import useHomePageNewsCardStyles from './HomePageNewsCard.styles';
import MarkdownLink from './MarkdownLink';

export interface HomePageNewsCardProps {
  description: string;
  imageSrc: string;
  learnMoreLabel?: string;
  href: string;
  imageLabel: string;
  title: string;
}

export default function HomePageNewsCard({
  description,
  imageSrc,
  href,
  title,
  imageLabel,
  learnMoreLabel,
}: HomePageNewsCardProps) {
  const {
    classes: {
      container,
      image,
      head,
      imageLabel: imageLabelStyle,
      description: descriptionStyle,
      link: linkStyle,
      title: titleStyle,
    },
  } = useHomePageNewsCardStyles();
  const { translate } = useTranslation();

  return (
    <DynamicallyRouted.Link href={href}>
      <Grid
        className={container}
        item
        container
        wrap='nowrap'
        direction='column'
        XSmall={12}
        Medium={6}
        XLarge={3}>
        <Grid container alignItems='center' className={head} wrap='nowrap'>
          <MarkdownImage alt={translate('Label.Image')} src={imageSrc} className={image} />
          <Typography className={imageLabelStyle} color='secondary' variant='overline'>
            {imageLabel}
          </Typography>
        </Grid>
        <Typography
          aria-roledescription={translate('Label.Title')}
          className={titleStyle}
          variant='h3'>
          {title}
        </Typography>
        <Typography
          aria-roledescription={translate('Label.Description')}
          className={descriptionStyle}
          variant='body1'
          color='secondary'>
          {description}
        </Typography>
        <MarkdownLink className={linkStyle} href={href}>
          <Button size='small' color='primary'>
            {learnMoreLabel ?? translate('Label.LearnMore')}
          </Button>
        </MarkdownLink>
      </Grid>
    </DynamicallyRouted.Link>
  );
}
